'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
var colors = require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
var fonts = require('../../../../themes/fonts.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
var baseTabs = require('../base-tabs/base-tabs.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const BaseStandardTabs = (props)=>{
    const { className , ...otherProps } = props;
    return /*#__PURE__*/ React__default.default.createElement(baseTabs.BaseTabs, _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-tabs__standard': true,
            [`${className}`]: !!className
        })
    }));
};
const Tabs = styled__default.default(BaseStandardTabs)`
  font-family: ${fonts.fontFamilyBook};
  font-size: 14px;
  line-height: 22px;

  .bf-tabs__tab {
    background-color: transparent;
    border: 0;
    border-bottom: 2px solid ${colors.BrandfolderHexColors.GrayBorder};
    border-radius: 0;
    color: ${colors.BrandfolderHexColors.GrayDark};
    cursor: pointer;
    display: block;
    flex: 1;
    font-family: ${fonts.fontFamilyBook};
    font-size: 14px;
    line-height: 22px;
    padding: 10px 5px;
    transition:
      border 0.2s ease,
      border-color 0.2s ease,
      color 0.2s ease;
    width: 100%;
    z-index: 1;

    &[aria-selected='true'] {
      border-bottom-color: ${colors.BrandfolderHexColors.Text};
      color: ${colors.BrandfolderHexColors.Text};
      cursor: default;
      font-family: ${fonts.fontFamilyMedium};
    }

    &[aria-disabled='true'] {
      border-bottom-color: ${colors.BrandfolderHexColors.GrayBorder};
      color: ${colors.BrandfolderHexColors.Gray};
      cursor: not-allowed;
    }

    &:focus:not([aria-disabled='true']):not([aria-selected='true']),
    &:hover:not([aria-disabled='true']):not([aria-selected='true']) {
      border-bottom-color: ${colors.BrandfolderHexColors.PurplePopsicle};
      color: ${colors.BrandfolderHexColors.PurplePopsicle};
    }
  }

  .bf-tabs__tablist {
    display: flex;
    min-width: 250px;
    position: relative;
  }

  .bf-tabs__tabpanel {
    margin-top: 15px;
    min-width: 250px;
    padding: 15px;
    position: relative;

    &[hidden] {
      display: none;
    }

    @media (min-width: 767px) {
      margin-top: 30px;
    }
  }

  .bf-tabs__slider {
    background-color: ${colors.BrandfolderHexColors.GrayDark};
    bottom: 0;
    display: block;
    height: 2px;
    left: 0;
    position: absolute;
    transition: left 0.2s ease;
    width: 100%;
  }

  .bf-tabs__underline {
    background-color: ${colors.BrandfolderHexColors.GrayBorder};
    bottom: 0;
    display: block;
    height: 2px;
    left: 0;
    position: absolute;
    width: 100%;
  }
`;
/**
 * Tabs widget that displays a `tablist`, `tab`, and `tabpanel` elements.
 * `caption`, `id`, and an array of `tabs` are all required props.
 *
 * Construct your tabs by using `StandardTab[]` to create an array that is passed
 * in to the `tabs` prop. Each tab should have a `tabButton` and `tabPanel` attribute.
 *
 * By default, the first tab will be activated on render. To specify a different tab
 * that should be active, use the `initialActiveIndex` prop. To programmatically change
 * to a tab after render, use the `changeToIndex` prop.
 *
 * There are two types of tabs:
 * [Manual activation](https://www.w3.org/WAI/ARIA/apg/example-index/tabs/tabs-manual.html) and
 * [automatic activation](https://www.w3.org/WAI/ARIA/apg/example-index/tabs/tabs-automatic.html).
 * By default, `activatePanelOnPrevNext` is `true` for automatic activation.
 *
 * More about tabs from W3C: https://www.w3.org/WAI/ARIA/apg/patterns/tabpanel/.
 *
 * @param props StandardTabsProps
 * @returns FunctionComponent<StandardTabsProps>
 */ const StandardTabs = (props)=>{
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(Tabs, _extends({}, props)));
};

exports.BaseStandardTabs = BaseStandardTabs;
exports.StandardTabs = StandardTabs;
//# sourceMappingURL=standard-tabs.js.map
